/*
  The golden karkhana (round 34): the movements of sections/vr-karkhana.liquid.
  - the film: once its still has arrived, the light spreads from the middle as a lamp is lit and the title comes in;
    the film itself loads only after the page, plays muted while it is on screen, and never for visitors who save
    data or ask for reduced motion;
  - one piece, many hands: while the stage holds, the scroll makes the piece, the step being made told beside it:
    with the house's design study (four pictures of one pair of chandbalis), the pencil drawing comes onto the
    paper from the earrings outwards, the gold rises into it from below, the stones open from the heart of each
    earring, a warm flash as the photograph takes the drawing's place, and one band of light crosses the jewellery (round 56; the
    reveals are masks in assets/vr-karkhana.css, set by --k1 to --k5); without it, the drawn jadau pendant
    (snippets/vr-jadau.liquid): the drawing, the gold poured into it, the stones set one by one, the drops hung
    and one band of light;
  - the crafts we keep: each niche's light comes on as it comes into view.
  The words of the sonar, and the photographs that open like doors, are the Our Story page's own
  (assets/vr-story.js). Visitors who ask for reduced motion see the page still and the pendant whole.
*/
(function () {
  'use strict';
  var root = document.querySelector('[data-vrk]');
  if (!root || root.getAttribute('data-vrk-ready')) return;
  root.setAttribute('data-vrk-ready', '1');
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  if (reduce) root.classList.add('is-still');
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function vh() { return window.innerHeight || document.documentElement.clientHeight; }

  /* ---- the pendant, made at progress P (0 to 1: the drawing, the gold, the setting, the finish) ---- */
  function vrkPiece(svg) {
    var q = function (sel) { return Array.prototype.slice.call(svg.querySelectorAll(sel)); };
    var vb = svg.viewBox.baseVal;
    var lines = q('.vrk-sk').map(function (el) { return { el: el, t: parseFloat(el.getAttribute('data-t')) || 0, dots: el.classList.contains('vrk-sk--dots') }; });
    var stones = q('.vrk-st').map(function (el) { return { el: el, t: parseFloat(el.getAttribute('data-t')) || 0 }; });
    var drops = q('.vrk-drop').map(function (el) { return { el: el, j: parseFloat(el.getAttribute('data-t')) || 0 }; });
    var pour = svg.querySelector('[data-vrk-pour]'), molten = svg.querySelector('[data-vrk-molten]'), shine = svg.querySelector('[data-vrk-shine]');
    var sketch = svg.querySelector('.vrk-sketch');
    var clamp = function (v, a, b) { return v < a ? a : v > b ? b : v; };
    var ease = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
    var back = function (t) { var c1 = 1.9, c3 = c1 + 1; return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2); };
    /* the gold is poured over the height of the gold itself, so it begins to rise at once */
    var gold = svg.querySelector('.vrk-gold'), gb = gold.getBBox();
    var top = gb.y - 6, height = gb.height + 12;
    var last = {};
    function set(el, prop, val) { if (el.__v && el.__v[prop] === val) return; (el.__v = el.__v || {})[prop] = val; el.style.setProperty(prop, val); }
    return function draw(P) {
      var p0 = clamp(P * 4, 0, 1), p1 = clamp(P * 4 - 1, 0, 1), p2 = clamp(P * 4 - 2, 0, 1), p3 = clamp(P * 4 - 3, 0, 1);
      /* I. the drawing: each line drawn in its turn */
      lines.forEach(function (l) { var v = clamp((p0 - l.t) / 0.14, 0, 1); if (l.dots) set(l.el, 'opacity', ease(v).toFixed(3)); else set(l.el, 'stroke-dashoffset', (1 - ease(v)).toFixed(4)); });
      /* the pencil fades as the gold covers it */
      set(sketch, 'opacity', (1 - clamp((p1 - 0.3) / 0.5, 0, 1)).toFixed(3));
      /* II. the gold, poured from below; a molten line at its level */
      var g = ease(clamp((p1 - 0.04) / 0.82, 0, 1));
      var y = top + (1 - g) * height;
      pour.setAttribute('y', y.toFixed(1));
      molten.setAttribute('y', (y - 9).toFixed(1));
      set(molten, 'opacity', (g > 0 && g < 1 ? Math.sin(Math.PI * g) : 0).toFixed(3));
      /* III. the stones, set one by one */
      stones.forEach(function (s) {
        var v = clamp((p2 - s.t) / 0.08, 0, 1);
        set(s.el, '--s', (0.35 + 0.65 * (v > 0 ? back(v) : 0)).toFixed(3));
        set(s.el, '--o', clamp(v * 2.2, 0, 1).toFixed(3));
      });
      /* IV. the drops hung, swinging to rest; one band of light */
      drops.forEach(function (d) {
        var u = clamp((p3 - 0.04 - d.j * 0.045) / 0.42, 0, 1);
        var a = 20 * Math.pow(1 - u, 2) * Math.cos(u * 2.6 * Math.PI) * (d.j % 2 ? -1 : 1);
        set(d.el, '--r', a.toFixed(2) + 'deg');
        set(d.el, '--o', clamp(u * 3, 0, 1).toFixed(3));
      });
      var sx = -60 + (vb.x + vb.width + 140) * ease(clamp((p3 - 0.42) / 0.48, 0, 1));
      shine.setAttribute('x', (p3 > 0.42 && p3 < 0.9 ? sx : -400).toFixed(1));
    };
  }

  /* ---- I. the film ---- */
  var hero = root.querySelector('[data-vrk-hero]');
  var film = hero && hero.querySelector('video[data-src]');
  var poster = hero && hero.querySelector('.vrk-hero__poster');
  var lit = false;
  function light() { if (lit) return; lit = true; root.classList.add('is-lit'); }
  if (reduce || !hero) light();
  else {
    if (!poster || (poster.complete && poster.naturalWidth)) window.setTimeout(light, 250);
    else { poster.addEventListener('load', function () { window.setTimeout(light, 150); }, { once: true }); poster.addEventListener('error', light, { once: true }); }
    window.setTimeout(light, 3000);
  }
  var conn = navigator.connection || {};
  var saving = conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '');
  if (film && !reduce && !saving) {
    var started = false, onScreen = true, pageReady = document.readyState === 'complete';
    var play = function () { var p = film.play(); if (p && p.catch) p.catch(function () {}); };
    var start = function () {
      if (started || !pageReady || !onScreen) return;
      started = true;
      film.addEventListener('playing', function () { film.classList.add('is-playing'); }, { once: true });
      film.src = film.getAttribute('data-src');
      play();
    };
    if (!pageReady) window.addEventListener('load', function () { pageReady = true; window.setTimeout(start, 300); }, { once: true });
    window.setTimeout(function () { pageReady = true; start(); }, 2500);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        onScreen = entries[0].isIntersecting;
        if (!started) { start(); return; }
        if (onScreen) play(); else film.pause();
      }, { threshold: 0.05 }).observe(hero);
    }
    document.addEventListener('visibilitychange', function () { if (!document.hidden && started && onScreen) play(); });
  }

  /* ---- III. one piece, many hands ---- */
  var life = root.querySelector('[data-vrk-life]');
  var run = life && life.querySelector('[data-vrk-run]');
  var svg = life && life.querySelector('[data-vrk-piece]');
  var study = life && life.querySelector('[data-vrk-study]');
  var pieceBox = life && life.querySelector('.vrk-life__piece');
  var steps = life ? Array.prototype.slice.call(life.querySelectorAll('[data-vrk-step]')) : [];
  var marks = life ? Array.prototype.slice.call(life.querySelectorAll('[data-vrk-mark]')) : [];
  var draw = null;
  try { if (svg) draw = vrkPiece(svg); } catch (e) { draw = null; }
  var lifeNow = 0, lifeTarget = 0, current = -1;
  function lifeProgress() {
    if (!run) return 0;
    var r = run.getBoundingClientRect(), span = r.height - vh();
    return span > 0 ? clamp(-r.top / span, 0, 1) : 1;
  }
  /* the design study at progress P: each picture over the one before, in the four steps */
  function studyEase(x) { return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; }
  function studySet(prop, v) { var s = v.toFixed(4); if (study['__' + prop] === s) return; study['__' + prop] = s; study.style.setProperty(prop, s); }
  function drawStudy(P) {
    var q0 = clamp(P * 4, 0, 1), q1 = clamp(P * 4 - 1, 0, 1), q2 = clamp(P * 4 - 2, 0, 1), q3 = clamp(P * 4 - 3, 0, 1);
    var k2 = studyEase(clamp((q1 - 0.04) / 0.82, 0, 1)), k3 = studyEase(clamp((q2 - 0.04) / 0.82, 0, 1));
    studySet('--k1', studyEase(clamp(q0 / 0.86, 0, 1)));
    studySet('--k2', k2);
    studySet('--melt', k2 > 0 && k2 < 1 ? Math.sin(Math.PI * k2) * 0.9 : 0);
    studySet('--k3', k3);
    studySet('--k3f', clamp((k3 - 0.95) / 0.05, 0, 1));
    var k4 = studyEase(clamp((q3 - 0.02) / 0.42, 0, 1));
    studySet('--k4', k4);
    studySet('--glow', k4 > 0 && k4 < 1 ? Math.pow(Math.sin(Math.PI * k4), 1.5) * 0.85 : 0);
    studySet('--k5', clamp((q3 - 0.5) / 0.42, 0, 1));
  }
  function drawLife(P) {
    if (draw) draw(P);
    if (study) drawStudy(P);
    if (pieceBox) {
      /* the sheet stays while the gold is poured into the drawing, and is lifted away once the gold is in */
      pieceBox.style.setProperty('--vrk-paper', (1 - clamp((P * 4 - 1.72) / 0.28, 0, 1)).toFixed(3));
      pieceBox.style.setProperty('--vrk-heat', (0.35 + 0.65 * clamp((P * 4 - 1) / 0.6, 0, 1)).toFixed(3));
    }
    var n = steps.length;
    if (!n) return;
    var i = Math.min(n - 1, Math.floor(P * n * 0.9999));
    if (i === current) return;
    current = i;
    steps.forEach(function (s, j) { s.classList.toggle('is-active', j === i); });
    marks.forEach(function (m, j) { m.classList.toggle('is-reached', j <= i); });
  }
  if (reduce) { if (draw) draw(1); steps.forEach(function (s) { s.classList.add('is-active'); }); }
  else drawLife(0);

  /* ---- V. the niches: their lights come on as they come into view ---- */
  var niches = Array.prototype.slice.call(root.querySelectorAll('[data-vrk-niche]'));
  if (!reduce && 'IntersectionObserver' in window) {
    var lamps = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (!e.isIntersecting) return; lamps.unobserve(e.target); e.target.classList.add('is-lit'); });
    }, { threshold: 0.35 });
    niches.forEach(function (n) { lamps.observe(n); });
  } else niches.forEach(function (n) { n.classList.add('is-lit'); });

  /* ---- one frame for everything that follows the page ---- */
  var ticking = false, smoothing = false;
  function frame() {
    ticking = false;
    lifeTarget = lifeProgress();
    if (!smoothing) { smoothing = true; window.requestAnimationFrame(smooth); }
  }
  function smooth() {
    var d = lifeTarget - lifeNow, busy = false;
    if (Math.abs(d) > 0.0002) { lifeNow += d * 0.12; busy = true; } else lifeNow = lifeTarget;
    drawLife(lifeNow);
    if (busy) window.requestAnimationFrame(smooth); else smoothing = false;
  }
  function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(frame); } }
  if (!reduce && run) {
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }
})();
